import React from "react";

export default function MCCDashboardWrapper({ children }) {
  return (
    <div className="flex flex-col gap-4">
      {children &&
        React.Children.map(children, (child) => React.cloneElement(child))}
    </div>
  );
}
